(function () {
  function initSection(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const tabs = Array.from(root.querySelectorAll('[data-tabbed-review-tab]'));
    const cards = Array.from(root.querySelectorAll('[data-tabbed-review-card]'));
    const track = root.querySelector('[data-tabbed-review-track]');
    const wrap = root.querySelector('[data-tabbed-review-track-wrap]');

    if (!tabs.length || !cards.length || !track || !wrap) return;

    let activeIndex = 0;
    let touchStartX = 0;

    function isMobile() {
      return window.matchMedia('(max-width: 767px)').matches;
    }

    function setActiveTab(index) {
      activeIndex = index;
      tabs.forEach((tab, i) => {
        tab.classList.toggle('is-active', i === index);
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });

      cards.forEach((card, i) => {
        card.hidden = isMobile() ? i !== index : false;
        card.style.order = i === index ? '-1' : String(i + 1);
      });

      if (isMobile()) {
        track.style.transform = `translateX(-${index * 100}%)`;
      } else {
        track.style.transform = 'none';
        const card = cards[index];
        if (card) {
          wrap.scrollTo({ left: Math.max(0, card.offsetLeft - 24), behavior: 'smooth' });
        }
      }
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => setActiveTab(index));
    });

    wrap.addEventListener(
      'touchstart',
      (event) => {
        if (!isMobile()) return;
        touchStartX = event.touches[0].pageX;
      },
      { passive: true }
    );

    wrap.addEventListener(
      'touchend',
      (event) => {
        if (!isMobile()) return;
        const delta = touchStartX - event.changedTouches[0].pageX;
        if (delta > 50 && activeIndex < cards.length - 1) {
          setActiveTab(activeIndex + 1);
        } else if (delta < -50 && activeIndex > 0) {
          setActiveTab(activeIndex - 1);
        }
      },
      { passive: true }
    );

    window.addEventListener('resize', () => setActiveTab(activeIndex));
    setActiveTab(0);
  }

  function initAll() {
    document.querySelectorAll('[data-product-tabbed-reviews]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-product-tabbed-reviews]');
    if (root) initSection(root);
  });
})();
